/* P97 — PDP v2.

   THIS FILE MUST NEVER TOUCH ADD TO CART OR THE SLIDE CART.
   The Add To Cart button is udesly's own submit inside the theme's Webflow
   form. udesly posts the item, re-reads the cart, renders the drawer, opens it,
   and lets the free-gift widget react — in that order. Doing any part of that
   from here cut ahead of its render and produced either a bounce to the
   collections page or a drawer that opened empty.

   What this file does, and all it does:
     - drives udesly's hidden option selects from the size/colour buttons
     - swaps the hero image and marks thumbnails
     - crosses out unavailable sizes
     - runs the sold-out email signup, and owns the tags it submits
     - asks Postscript to render its back-in-stock button above the email one
*/
(function () {
  function slug(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  /* ---------- Postscript back-in-stock ----------

     Postscript's SDK puts a small API on window.Postscript.backInStock:

       find()                    -> resolves to the id of the shop's BIS popup
       renderTeaser(id, element) -> renders their own trigger into any element
       open(id, context)         -> opens the popup directly

     So there is no need to hunt the DOM for their banner or proxy clicks at it,
     which is what this file used to do. We hand them a slot above the email
     signup and they render their real button into it — their markup, their
     styling from the Postscript dashboard, their handler.

     Everything before this went looking for a rendered element to move. There
     was never one to find: their widget lives in a cross-origin iframe
     (#ps__widget inside #ps__widget_container) which is display:none until the
     popup opens, and the on-page trigger is only created when something calls
     renderTeaser. Nothing on the page ever did.

     RENDER IT ONCE AND THEN LEAVE IT ALONE. renderTeaser is a no-op on any
     call after the first, so emptying the slot on a variant change — which an
     earlier version of this did, to re-bind the teaser to the new size —
     destroys the button permanently and nothing brings it back. Their popup
     reads the product from the page when it opens, and render() below keeps
     ?variant= current, so there is nothing to re-bind anyway.

     If the SDK is missing (an ad blocker, say) or find() comes back empty
     because no Back in Stock popup exists on the account, the slot stays empty
     and collapses to nothing. No dead button, and no gap above the email one. */

  function psWhenReady(cb) {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var P = window.Postscript;
      if (P && P.backInStock && P.backInStock.find && P.backInStock.renderTeaser) {
        clearInterval(timer);
        cb(P);
      } else if (tries > 60) {
        clearInterval(timer);
      }
    }, 250);
  }

  function psStyles() {
    if (document.getElementById('pv2-ps-style')) return;
    var css = document.createElement('style');
    css.id = 'pv2-ps-style';
    css.textContent =
      '.pv2__ps-slot{display:block;width:100%;margin-bottom:8px}' +
      '.pv2__ps-slot:empty{display:none}';
    (document.head || document.documentElement).appendChild(css);
  }

  function init(root) {
    if (root.dataset.pv2Ready === '1') return;
    root.dataset.pv2Ready = '1';

    var dataEl = root.querySelector('[data-pv2-data]');
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = DATA.variants || [];
    if (!variants.length) return;

    var heroImg = root.querySelector('[data-pv2-hero-img]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pv2-thumb]'));
    var valueBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pv2-value]'));
    var valueLabels = Array.prototype.slice.call(root.querySelectorAll('[data-pv2-option-value]'));
    var priceEl = root.querySelector('[data-pv2-price]');
    var compareEl = root.querySelector('[data-pv2-compare]');
    var shareBtn = root.querySelector('[data-pv2-share]');

    /* udesly's submit and its hidden selects — read only, never clicked */
    var atcInput = root.querySelector('[data-pv2-atc]');
    var soldOutBtn = root.querySelector('[data-pv2-soldout]');
    var legacySelects = Array.prototype.slice.call(root.querySelectorAll('[data-pv2-legacy-select]'));

    var notifyOpen = root.querySelector('[data-pv2-notify-open]');
    var notifyWrap = root.querySelector('[data-pv2-notify]');
    var smsHint = root.querySelector('[data-pv2-sms-hint]');
    var nmForm = root.querySelector('[data-pv2-nm-form]');
    var nmTags = root.querySelector('[data-pv2-nm-tags]');
    var nmSubmit = root.querySelector('[data-pv2-nm-submit]');
    var nmErr = root.querySelector('[data-pv2-nm-err]');
    var nmCancel = root.querySelector('[data-pv2-nm-cancel]');
    var nmDone = root.querySelector('[data-pv2-nm-done]');
    var nmEmail = nmForm ? nmForm.querySelector('input[name="contact[email]"]') : null;
    var nmSubmitLabel = nmSubmit ? nmSubmit.textContent : 'Notify Me';

    var current = null;
    for (var k = 0; k < variants.length; k++) {
      if (variants[k].id === DATA.currentId) { current = variants[k]; break; }
    }
    if (!current) current = variants[0];

    var selected = current.options.slice();

    /* THE SELECTS HOLD HANDLEIZED VALUES, SO SEED THE HANDLES SLUGGED.
       Liquid renders every <option value> through | handle, so the select for a
       single-variant product holds 'default-title', never 'Default Title'.
       This used to start as a raw copy of `selected` and was only corrected
       further down from the option buttons' data-handle — but a product with
       one variant renders no option buttons, so nothing corrected it. Assigning
       a value no <option> carries silently blanks the select, which fires a
       change, and udesly reads a blank option1 as "no variant matched" and
       disables its own submit. That was the randomly missing Add To Cart: it
       only landed when this file's render() ran after udesly had already
       aligned the select, and only ever on products with no options to click. */
    var selectedHandles = selected.map(slug);

    var optionCount = selected.length;
    var lastVariantId = current.id;
    var productSlug = slug(DATA.handle);

    valueBtns.forEach(function (btn) {
      if (!btn.classList.contains('is-selected')) return;
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      selectedHandles[idx] = btn.getAttribute('data-handle') || slug(btn.getAttribute('data-value'));
    });

    /* ---------- Postscript's button, above the email one ---------- */
    var psSlot = null;

    if (notifyOpen) {
      psStyles();
      psSlot = document.createElement('div');
      psSlot.className = 'pv2__ps-slot';
      psSlot.setAttribute('data-pv2-ps-slot', '');
      notifyOpen.insertAdjacentElement('beforebegin', psSlot);
      if (smsHint) smsHint.hidden = true;

      psWhenReady(function (P) {
        Promise.resolve(P.backInStock.find()).then(function (id) {
          if (!id) return;
          P.backInStock.renderTeaser(id, psSlot);
        }).catch(function () { /* their end — leave the slot empty */ });
      });
    }

    function setMoney(el, value) {
      if (!el) return;
      el.innerHTML = value == null ? '' : value;
    }

    /* ---------- image prefetch ---------- */
    var cache = {};

    function warm(src, urgent) {
      if (!src) return null;
      if (cache[src]) return cache[src];
      var img = new Image();
      if (urgent && 'fetchPriority' in img) img.fetchPriority = 'high';
      img.decoding = 'async';
      cache[src] = img;
      img.src = src;
      return img;
    }

    function isReady(src) {
      var img = cache[src];
      return !!(img && img.complete && img.naturalWidth > 0);
    }

    function warmAll() {
      var urls = [];
      thumbs.forEach(function (t) { urls.push(t.getAttribute('data-full')); });
      variants.forEach(function (v) { if (v.mediaSrc) urls.push(v.mediaSrc); });
      var i = 0;
      (function next() {
        if (i >= urls.length) return;
        warm(urls[i++]);
        setTimeout(next, 120);
      })();
    }

    var whenIdle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 500); };
    if (document.readyState === 'complete') {
      whenIdle(warmAll);
    } else {
      window.addEventListener('load', function () { whenIdle(warmAll); });
    }

    function warmForValue(btn) {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      var val = btn.getAttribute('data-value');
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[idx] === val && variants[i].mediaSrc) {
          warm(variants[i].mediaSrc, true);
          return;
        }
      }
    }

    ['pointerenter', 'touchstart'].forEach(function (ev) {
      thumbs.forEach(function (t) {
        t.addEventListener(ev, function () { warm(t.getAttribute('data-full'), true); }, { passive: true });
      });
      valueBtns.forEach(function (btn) {
        btn.addEventListener(ev, function () { warmForValue(btn); }, { passive: true });
      });
    });

    /* ---------- gallery ---------- */
    function markThumb(mediaId) {
      for (var i = 0; i < thumbs.length; i++) {
        var on = mediaId != null && thumbs[i].getAttribute('data-media-id') === String(mediaId);
        thumbs[i].classList.toggle('is-active', on);
      }
    }

    function setHero(src, mediaId) {
      if (!heroImg || !src) return;
      if (heroImg.getAttribute('src') === src) { markThumb(mediaId); return; }
      markThumb(mediaId);

      if (isReady(src)) {
        heroImg.classList.remove('is-fading');
        heroImg.src = src;
        return;
      }

      heroImg.classList.add('is-fading');
      var pre = warm(src, true);
      var done = function () {
        heroImg.src = src;
        heroImg.classList.remove('is-fading');
      };
      if (pre.complete && pre.naturalWidth > 0) {
        done();
      } else {
        pre.addEventListener('load', done, { once: true });
        pre.addEventListener('error', function () { heroImg.classList.remove('is-fading'); }, { once: true });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setHero(t.getAttribute('data-full'), t.getAttribute('data-media-id'));
      });
    });

    /* ---------- variant matching ---------- */
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < optionCount; j++) {
          if (variants[i].options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function valueAvailable(index, value) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[index] !== value) continue;
        var ok = true;
        for (var j = 0; j < optionCount; j++) {
          if (j === index) continue;
          if (v.options[j] !== selected[j]) { ok = false; break; }
        }
        if (ok && v.available) return true;
      }
      return false;
    }

    function valueExists(index, value) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[index] === value) return true;
      }
      return false;
    }

    /* udesly resolves the variant from these selects. Their values are
       handleized ('7 3/8' becomes '7-3-8'), so feed them handles. */
    function syncLegacyForm() {
      legacySelects.forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-option-index'), 10);
        var want = selectedHandles[idx];
        if (want && sel.value !== want) {
          sel.value = want;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* ---------- sold-out email signup ---------- */
    var SIGNED_KEY = 'p97_bis_v1';
    var PENDING_KEY = 'p97_bis_pending';

    function readSigned() {
      try { return JSON.parse(window.localStorage.getItem(SIGNED_KEY) || '{}'); } catch (e) { return {}; }
    }
    function alreadySigned(id) { return !!readSigned()[String(id)]; }
    function markSigned(id) {
      try {
        var s = readSigned();
        s[String(id)] = new Date().toISOString();
        window.localStorage.setItem(SIGNED_KEY, JSON.stringify(s));
      } catch (e) {}
    }

    /* THIS FUNCTION DECIDES WHAT SHOPIFY ACTUALLY RECEIVES.
       The value= on the hidden tags input in the section file is only a
       fallback: this runs on first render, before anyone can submit, and
       overwrites it. Editing the Liquid value alone changes nothing. */
    function updateTags(v) {
      if (!nmTags) return;
      var tags = ['back-in-stock', 'bis-' + productSlug];
      if (v && v.title) tags.push('bis-' + productSlug + '-' + slug(v.title));
      if (v) tags.push('waitlist-' + v.id);
      nmTags.value = tags.join(', ');
    }

    function openForm(focusIt) {
      if (nmForm) nmForm.hidden = false;
      if (nmDone) nmDone.hidden = true;
      if (notifyOpen) notifyOpen.hidden = true;
      if (focusIt && nmEmail) nmEmail.focus();
    }
    function showDone() {
      if (nmForm) nmForm.hidden = true;
      if (nmDone) nmDone.hidden = false;
      if (notifyOpen) notifyOpen.hidden = true;
      if (notifyWrap) notifyWrap.hidden = false;
    }
    function resetNotify() {
      if (nmForm) nmForm.hidden = true;
      if (nmDone) nmDone.hidden = true;
      if (notifyOpen) notifyOpen.hidden = false;
      if (nmErr) nmErr.textContent = '';
      if (nmSubmit) { nmSubmit.disabled = false; nmSubmit.textContent = nmSubmitLabel; }
    }

    if (notifyOpen) {
      notifyOpen.addEventListener('click', function () {
        if (current && alreadySigned(current.id)) { showDone(); return; }
        openForm(true);
      });
    }
    if (nmCancel) nmCancel.addEventListener('click', resetNotify);

    if (nmForm) {
      nmForm.addEventListener('submit', function (e) {
        var email = nmEmail ? nmEmail.value.trim() : '';
        if (!/\S+@\S+\.\S+/.test(email)) {
          e.preventDefault();
          if (nmErr) nmErr.textContent = 'Please enter a valid email address.';
          return;
        }
        if (nmErr) nmErr.textContent = '';
        updateTags(current);
        try { window.localStorage.setItem(PENDING_KEY, String(current ? current.id : '')); } catch (ex) {}
        if (nmSubmit) { nmSubmit.disabled = true; nmSubmit.textContent = 'Adding...'; }
      });
    }

    var justSignedUp = false;
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.get('customer_posted') === 'true') {
        var pending = window.localStorage.getItem(PENDING_KEY);
        if (pending) { markSigned(pending); window.localStorage.removeItem(PENDING_KEY); }
        justSignedUp = true;
        qs.delete('customer_posted');
        window.history.replaceState({}, '', window.location.pathname + (qs.toString() ? '?' + qs.toString() : ''));
      }
    } catch (e) {}

    /* ---------- render ---------- */
    function render() {
      valueBtns.forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var val = btn.getAttribute('data-value');
        btn.classList.toggle('is-selected', selected[idx] === val);
        if (btn.classList.contains('pv2__pill')) {
          btn.classList.toggle('is-soldout', !valueAvailable(idx, val));
        } else if (!valueExists(idx, val)) {
          btn.disabled = true;
        }
      });

      valueLabels.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10);
        el.textContent = selected[idx] || '';
      });

      var v = findVariant(selected);
      current = v;

      if (v) setMoney(priceEl, v.price);
      if (compareEl) {
        if (v && v.compare) { setMoney(compareEl, v.compare); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }

      syncLegacyForm();

      var buyable = !!(v && v.available);
      if (atcInput) atcInput.hidden = !buyable;
      if (soldOutBtn) soldOutBtn.hidden = buyable;

      var changed = !v || v.id !== lastVariantId;
      if (changed) {
        resetNotify();
        lastVariantId = v ? v.id : null;
      }

      updateTags(v);

      if (notifyWrap) {
        notifyWrap.hidden = buyable;
        if (!buyable && v && alreadySigned(v.id)) showDone();
      }

      if (v && v.mediaSrc) setHero(v.mediaSrc, v.mediaId);

      if (v && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    valueBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        selected[idx] = btn.getAttribute('data-value');
        selectedHandles[idx] = btn.getAttribute('data-handle') || slug(btn.getAttribute('data-value'));

        if (!findVariant(selected)) {
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].options[idx] === selected[idx]) {
              selected = variants[i].options.slice();
              valueBtns.forEach(function (b) {
                var bi = parseInt(b.getAttribute('data-option-index'), 10);
                if (b.getAttribute('data-value') === selected[bi]) {
                  selectedHandles[bi] = b.getAttribute('data-handle') || slug(selected[bi]);
                }
              });
              break;
            }
          }
        }
        render();
      });
    });

    /* ---------- share ---------- */
    if (shareBtn) {
      var toast = shareBtn.querySelector('[data-pv2-share-toast]');
      var toastTimer = null;
      var showToast = function (msg) {
        if (!toast) return;
        toast.textContent = msg;
        toast.hidden = false;
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { toast.hidden = true; }, 1800);
      };

      shareBtn.addEventListener('click', function () {
        var url = window.location.href;
        var title = DATA.title || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            showToast('Link copied');
          }).catch(function () {
            window.prompt('Copy this link', url);
          });
          return;
        }
        window.prompt('Copy this link', url);
      });
    }

    /* ---------- size guide modal ---------- */
    var modal = document.querySelector('[data-pv2-modal]');
    var openBtn = root.querySelector('[data-pv2-sizeguide]');
    if (modal && openBtn) {
      var close = function () { modal.hidden = true; document.body.style.overflow = ''; };
      openBtn.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      Array.prototype.forEach.call(modal.querySelectorAll('[data-pv2-modal-close]'), function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    }

    render();

    if (justSignedUp) {
      showDone();
      if (notifyWrap && notifyWrap.scrollIntoView) {
        notifyWrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pv2-root]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-pv2-root]') : null;
    if (el) init(el);
  });
})();
